import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import PageBottomBar from '../../../components/Page/BottomBar';
import Utils from '../../../utils';

const mapStateToProps = (state: StoreState) => {
	const { appInfos, driveList, galleryInfos: { config} } = state;
	const isMultiApp = Utils.isMultiApp(appInfos);
	const privateDirId = Utils.getPrivateDirId(driveList, config);
	return {
		showFolderCreation: isMultiApp && !!privateDirId
	};
};

export default connect(mapStateToProps)(PageBottomBar);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Page/BottomBar/index.ts